export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex-shrink-0 w-48 md:w-56">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20movie%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20elegant%20video%20player%20UI%20design%20with%20golden%20and%20crimson%20accents%2C%20clean%20app%20screen%20presentation%20on%20device%2C%20simple%20neutral%20background&width=500&height=500&seq=app-qr-51video&orientation=squarish"
              alt="51视频移动端界面预览"
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">随时随地，畅享影视</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              51视频完美适配手机浏览器，无需下载APP即可获得流畅的移动观影体验。推荐将51视频添加到手机主屏幕，一键直达，追剧更便捷。
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              <div className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-android-line text-lg"></i>Android 访问
              </div>
              <div className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-line text-lg"></i>iOS 访问
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}